module.exports = __webpack_public_path__ + "img/H-63-ER-1200-B.f5c1555b.png";